import { createContext } from "react";

const PageContext = createContext({
    topicFilter: [],
    roleFilter: [],
    ageFilter: [],
    contentTypeFilter: [],
    specialtyFilter: [],
    setTopicFilter: (filter) => (filter),
    setRoleFilter: (filter) => (filter),
    setAgeFilter: (filter) => (filter),
    setContentTypeFilter: (filter) => (filter),
    setSpecialtyFilter: (filter) => (filter),
    activeFilter: false,
    setActiveFilter: (activeFilter) => (activeFilter),
});

export default PageContext;
